import { useWeb3React } from "@web3-react/core";
import { FC, ReactElement, useEffect } from "react";
import { shortCutAddr } from "../../utils";
import { connectors } from "../../web3/web3-connectors";
import { If } from "../control";
import "./Connector.scss";
import { WlData } from "../../types";
import showAlert from "../alert";

const Connector: FC<{ userWhiteList: WlData }> = ({ userWhiteList }) => {
  // 连接，账户，钱包
  const { activate, active, error, account, library,deactivate } = useWeb3React();
  useEffect(()=>{
    if(error) {
      showAlert({
        title: "Connect ETH Mainnet Failed",
        content: `message:${error?.message}; please check your wallet`,
        success: false,
      });
    }
  },[error]);

  let connectBtn: ReactElement;
  if (!active) {
    connectBtn = (
      <div
        onClick={() => activate(connectors.injected)}
        className="btn btn-not-connected"
      >
        Connect
      </div>
    );
  } else {
    connectBtn = (
      <div className="btn btn-connected">
        <span className="account-addr"> {shortCutAddr(account!!)}</span>
        <div className="disconnect-icon" onClick={deactivate}></div>
        {/* <UserPermBox userWhiteList={userWhiteList}></UserPermBox> */}
      </div>
    );
  }

  return <div className="connect-btn">{connectBtn}</div>;
};

const UserPermBox: FC<{ userWhiteList: WlData }> = ({ userWhiteList }) => {
  const { wl1, wl2 } = userWhiteList;
  return <div className="connect-box">
    {wl1 ? <div className="user-wl user-wl-1"></div>: null}
    {wl2 ? <div className="user-wl user-wl-2"></div>: null}
    {!(wl1 || wl2)? <div className="user-wl user-wl-none"></div> : null}
  </div>;
};

function ConnectModal() {
  const { activate, active, error, account, library } = useWeb3React();
  return (
    <div className="my-web3-modal">
      <div className="my-web3-modal--window">
        <div className="button" onClick={() => activate(connectors.injected)}>
          Metamask
        </div>
        <div
          className="button"
          onClick={() => activate(connectors.walletconnect)}
        >
          WalletConnect
        </div>
      </div>
    </div>
  );
}
export default Connector;
